import React, { Component } from 'react';
import './dashboards.css';
import ScrollArea from 'react-scrollbar';
import Moment from 'react-moment';
import { IoIosAddCircleOutline } from 'react-icons/io';
import UniqId from 'uniqid';

export default class Dashboards extends Component {
  gridItemStyle = {
    width: '200px',
    height: '200px',
    float: 'left',
    margin: '10px'
  };

  getCreationDate = item => {
    return <Moment fromNow>{item.creationDate}</Moment>;
  };

  renderTaskBoard = item => {
    return this.props.renderTaskBoard(item);
  };

  getDashboardItemToRender = item => {
    const backgroundStyle = {
      background: item.themeColor
    };

    const titleStyle = {
      color: item.themeColor
    };

    return (
      <div
        className="dashboard-grid-item"
        onClick={() => {
          this.renderTaskBoard(item);
        }}
        style={this.gridItemStyle}
        key={UniqId()}>
        <div className="grid-item-title" style={titleStyle}>
          {item.name}
        </div>
        <div className="grid-item-tags">
          <span className="tags-title">Tags :</span>
          {item.tags.map(item => {
            return (
              <span
                className="tags-chips"
                style={backgroundStyle}
                key={UniqId()}>
                {item}
              </span>
            );
          })}
        </div>
        <div className="grid-item-actions">
          <span className="grid-item-creation-date">
            {this.getCreationDate(item)}
          </span>
        </div>
      </div>
    );
  };

  render() {
    return (
      <ScrollArea
        className="list-dashboards"
        smoothScrolling={true}
        contentStyle={{ paddingBottom: '20px' }}>
        <h2 className="page-title">Dashboards</h2>
        {this.props.getAllDashboards().map(item => {
          return this.getDashboardItemToRender(item);
        })}

        <div
          className="dashboard-grid-item"
          style={this.gridItemStyle}
          onClick={() => {
            this.props.setRenderedPage('newDashboard');
          }}>
          <IoIosAddCircleOutline className="add-dashboard-icon" />
        </div>
      </ScrollArea>
    );
  }
}
